import { createApp } from 'vue'
import App from './Pages/_mainLayout.vue'
import Statistics from "@/Pages/Statistics.vue";
import AutoLogin from "@/Pages/AutoLogin.vue";
import NotFound from "@/Pages/NotFound.vue"

import { createRouter, createWebHistory } from 'vue-router'

import 'devextreme/dist/css/dx.softblue.css';
import "@devexpress/analytics-core/dist/css/dx-analytics.common.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.light.css";
import "devexpress-reporting/dist/css/dx-webdocumentviewer.css";
import './assets/style.css'

const routes = [
    { path: '/', component: Statistics, meta: { Title: "Статистика приёма", Roles:["Администратор"], IsNavigation:true } },
    { path: '/login', component: AutoLogin },
    { path: '/:pathMatch(.*)*', component: NotFound, meta: { Title: "Страница не найдена" } }
  ]

const router = createRouter({
  // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
  history: createWebHistory(),
  routes, // short for `routes: routes`
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.Title ? to.meta.Title : "Статистика приёма"
  next()
})

let app = createApp(App)
app.use(router)
app.mount('#app')